import React from "react";
import coin1 from '../assets/images/coins/coin_1.webp';
import coin2 from '../assets/images/coins/coin_2.webp';

interface ModalProps {
    onClose: VoidFunction
}

export const ModalPoints = ({ onClose } : ModalProps) => {

    const getImages = (image: string, repeat: number) => {
        return (
            Array.from({ length: repeat }, (_, i) => i + 1).map((num) => (
                <span key={num}>
                    <img src={image} style={{ width: '1.5em', height: 'auto' }} />
                </span>
            ))
        )
    }


    return (
        <div className="modal">
            <div className="modal-body modal-points-body">
            <div className="button-close">
                <button onClick={onClose} className="ft-EricssonGA628">
                    X
                </button>
            </div>
              <div className="container ft-EricssonGA628">
                <p className="text-center title">
                    Sistema de puntuación:
                </p>
                <div className="table">
                    <ol>
                        <li> 
                            <div>
                               <span>
                                    Pregunta bien respondida al primer intento: <span className="points">50 puntos</span>
                               </span>
                                <span className="coins">
                                    {getImages(coin1, 5)}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span>
                                    Pregunta bien respondida al segundo intento: <span className="points">40 puntos</span>
                                </span>
                                <span className="coins">
                                    {getImages(coin1, 4)}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span>
                                    Pregunta bien respondida al tercer intento: <span className="points">30 puntos</span>
                                </span>
                                <span className="coins">
                                    {getImages(coin1, 3)}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div>
                                <span>
                                    Pregunta bien respondida al cuarto intento: <span className="points">20 puntos</span>
                                </span>
                                <span className="coins">
                                    {getImages(coin1, 2)}
                                </span>
                            </div>
                        </li>
                        <li>
                           <div>
                                <span>
                                    Pregunta bien respondida al quinto intento: <span className="points">10 puntos</span>
                                    <br />
                                    (intentos en adelante todas suman 10 puntos c/u)
                                </span>

                                <span className="coins">
                                    {getImages(coin1, 1)}
                                </span>
                               
                           </div>
                        </li>
                        <li>
                            <div>
                                <span>
                                    Todas las preguntas (curso completo) respondidas correctamente al primer intento, se le adiciona <span className="points">200 puntos de bono</span>.
                                </span>
                                {getImages(coin2, 2)}
                            </div>
                        </li>
                        <li>
                           <div>
                            <span>
                                    Todas las preguntas respondidas correctamente al primer intento, pero con un error, se le adiciona <span className="points"> 100 puntos</span>.
                                </span>
                                {getImages(coin2, 1)}
                           </div>
                        </li>
                        <li>
                            x2 y x4, Pendientes de valor con bono.
                        </li>
                    </ol>
                </div>
              </div>
            </div>
        </div>
    )
}